<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-cash-body">
            <div class="dw-cash-hero">
                <span class="dw-cash-hero-label">{{ register?.name || 'Net Bakiye' }}</span>
                <span class="dw-cash-hero-value">{{ netFormatted }}</span>
            </div>
            <div class="dw-cash-bars">
                <div class="dw-cash-bar-item">
                    <div class="dw-cash-bar-head">
                        <span class="dw-cash-bar-lbl"><i class="bi bi-arrow-down-circle-fill" style="color: var(--bs-success)"></i> Gelir</span>
                        <span class="dw-cash-bar-val" style="color: var(--bs-success)">{{ incomeFormatted }}</span>
                    </div>
                    <div class="dw-cash-bar-track">
                        <div class="dw-cash-bar-fill" style="width: 100%; background: var(--bs-success)"></div>
                    </div>
                </div>
                <div class="dw-cash-bar-item">
                    <div class="dw-cash-bar-head">
                        <span class="dw-cash-bar-lbl"><i class="bi bi-arrow-up-circle-fill" style="color: var(--bs-danger)"></i> Gider</span>
                        <span class="dw-cash-bar-val" style="color: var(--bs-danger)">{{ expenseFormatted }}</span>
                    </div>
                    <div class="dw-cash-bar-track">
                        <div class="dw-cash-bar-fill" :style="{ width: expensePercent + '%', background: 'var(--bs-danger)' }"></div>
                    </div>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'cash_register',
    titleKey: 'common.dashboard.widgetTitles.cash_register',
    icon: 'bi-cash-stack',
    accent: 'var(--bs-success)',
    accentBg: 'rgba(var(--bs-success-rgb, 80, 205, 137), 0.12)',
    glassRgb: '80, 205, 137',
    defaultCol: 1,
    defaultRow: 1,
    multiInstance: true,
    source: { type: 'statistics', key: 'cash_registers' },
    defaultConfig: { cash_register_id: null },
    configFields: [
        { key: 'cash_register_id', label: 'common.dashboard.widgetFields.cashRegister', type: 'cash_register_select' },
    ],
    extractStatistics(stats, config) {
        const list = Array.isArray(stats?.cash_registers) ? stats.cash_registers : [];
        if (!list.length) return null;
        if (config?.cash_register_id) {
            return list.find(r => r.id === config.cash_register_id) || list.find(r => r.is_default) || list[0];
        }
        return list.find(r => r.is_default) || list[0];
    },
};

function fmt(n) {
    return (parseFloat(n) || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 });
}

export default {
    name: 'CashRegisterWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        register() {
            return this.apiData || null;
        },
        income() {
            const r = this.register;
            return (parseFloat(r?.transaction_income) || 0) + (parseFloat(r?.manual_in) || 0);
        },
        expense() {
            const r = this.register;
            return (parseFloat(r?.transaction_expense) || 0) + (parseFloat(r?.manual_out) || 0);
        },
        incomeFormatted() { return fmt(this.income); },
        expenseFormatted() { return fmt(this.expense); },
        netFormatted() { return fmt(this.register?.net_balance ?? (this.income - this.expense)); },
        expensePercent() {
            if (!this.income) return 0;
            return Math.min(100, Math.round((this.expense / this.income) * 100));
        },
    },
};
</script>
